import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeliveryExecutiveComponent } from './delivery-executive.component';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule, MatRippleModule, MatSidenavModule, MatToolbarModule } from "@angular/material";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../material.module";
import { TbWaterfallModule } from "../../tb/tb-waterfall/tb-waterfall.module";



@NgModule({
  declarations: [DeliveryExecutiveComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    MatRippleModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    TbWaterfallModule,
    RouterModule
  ],
  exports: [DeliveryExecutiveComponent]
})
export class DeliveryExecutiveModule { }
